import { render, staticRenderFns } from "./BankDetail.vue?vue&type=template&id=07a452f0&scoped=true"
import script from "./BankDetail.vue?vue&type=script&lang=js"
export * from "./BankDetail.vue?vue&type=script&lang=js"
import style0 from "./BankDetail.vue?vue&type=style&index=0&id=07a452f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a452f0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2DesktopProfilesBankAddEmptyCard: require('/app/components/Theme2/Desktop/Profiles/BankAddEmptyCard.vue').default,Theme2DesktopProfilesBankAccountCard: require('/app/components/Theme2/Desktop/Profiles/BankAccountCard.vue').default,Theme2DesktopProfilesCryptoEmptyCard: require('/app/components/Theme2/Desktop/Profiles/CryptoEmptyCard.vue').default,Theme2DesktopProfilesCryptoWalletCard: require('/app/components/Theme2/Desktop/Profiles/CryptoWalletCard.vue').default,Theme2DesktopProfilesAddBankAccountInternational: require('/app/components/Theme2/Desktop/Profiles/AddBankAccountInternational.vue').default,Theme2DesktopProfilesAddBankAccountLao: require('/app/components/Theme2/Desktop/Profiles/AddBankAccountLao.vue').default})
